import {
  ENVIRONMENT_MISMATCH_IS_PROD,
  ENVIRONMENT_MISMATCH_IS_SANDBOX,
  FLOW_MISMATCH,
  NO_DECISION_FOUND,
  SingleDecisionQueryErrorReason,
  VERSION_MISMATCH,
} from "src/api/decisionHistoryV2/decisionHistoryQueries";
import { assertUnreachable } from "src/utils/typeUtils";

export const getHistoryEmptyStateWording = (
  reason: SingleDecisionQueryErrorReason | "emptyData",
): { headline: string; description: string } => {
  switch (reason) {
    case ENVIRONMENT_MISMATCH_IS_PROD:
      return {
        headline: "Environment mismatch",
        description: "The decision you searched for is a live decision",
      };
    case ENVIRONMENT_MISMATCH_IS_SANDBOX:
      return {
        headline: "Environment mismatch",
        description: "The decision you searched for is a sandbox decision",
      };
    case FLOW_MISMATCH:
    case VERSION_MISMATCH:
    case NO_DECISION_FOUND:
      return {
        headline: "No decision found",
        description: "Make sure your input is correct or search a different ID",
      };
    case "emptyData":
      return {
        headline: "No results found",
        description:
          "Try adjusting the search or filter to find what you are looking for",
      };
    default:
      return assertUnreachable(reason);
  }
};
